module.exports = __webpack_public_path__ + "img/ev-menu-banner.3d3a6b26.jpg";